<div *ngIf="element.url" style="text-align: left;">
  <img [src]="getImageUrl()" [attr.alt]="element.altText"  [ngStyle]="{'width.em': (20/100)*(element.scale)}" />
</div>